
import axios, { AxiosResponse } from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import UmbracoApiService from "@/services/UmbracoApiService";
import WsdlService from "@/services/WsdlService";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import Swal from "sweetalert2";
import ServicioNotificacionBalanceModel, {
    UserBalanceModel,
} from "@/models/ServicioNotificacionBalance/ServicioNotificacionBalanceModel";
import AfiliadoService from "@/services/AfiliadoService";

@Component({})
export default class NotificationBalanceResult extends Vue {
    @Prop() tipoFondo: FundTypeObj;
	public afiliadoService: AfiliadoService = new AfiliadoService();
	public name: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
	public isEmailNotification: boolean = false;
	public isCelNotification: boolean = false;
    public diaBalance:number = 0;
    public wsdlService: WsdlService = new WsdlService();

    public days: number[] = [];

    constructor() {
        super();
    }
    public async procesar() {
        let ip = (await this.afiliadoService.getUserIpAddress()).data.ip;
        let email = this.tipoFondo.tipofondos.emailusuario + '@' + this.tipoFondo.tipofondos.emailservidor;
        const requestBodyMail = {
            ip: ip,
            account: this.tipoFondo.tipofondos.codcuenta.toString(),
            fundType: this.tipoFondo.tipofondos.tipofondo.toString(),
            name: this.name,
            email:email,
            activate: this.isEmailNotification,
            diaBalance: this.diaBalance.toString()
			};

            const requestBodyCell = {
            ip: ip,
            account: this.tipoFondo.tipofondos.codcuenta.toString(),
            fundType: this.tipoFondo.tipofondos.tipofondo.toString(),
            activate: this.isCelNotification
			};

        if(this.isEmailNotification && this.diaBalance == 0){
             Swal.fire({
                text: 'Debe seleccionar el día que desea recibir su notificación para procesar su solicitud',
                icon: "error",
                showConfirmButton: true,
                confirmButtonText: "Ok",
            });
            this.isEmailNotification = this.tipoFondo.tipofondos.balancexmail === '1';
            return;
        }
            await this.wsdlService.postNotificacionBalanceEmail(requestBodyMail);
            await this.wsdlService.postNotificacionBalanceCel(requestBodyCell);
           this.$emit('nextStep');
		   this.$emit('updateNotificationData', this.isEmailNotification, this.isCelNotification);
            
	}
    returnHome() {
		this.$emit('returnHome');
    }
	public updateUser(){
		this.$emit('updateUser');
	}

    async mounted() {
        for (let index = 1; index <= 31; index++) {
            this.days.push(index);
        }
        console.log("this.tipoFondo.tipofondos",this.tipoFondo.tipofondos)
        this.isEmailNotification = this.tipoFondo.tipofondos.balancexmail === '1';
        this.isCelNotification = this.tipoFondo.tipofondos.balancexcelular === '1';
        if(this.tipoFondo.tipofondos.balancexmail !== '1'){
            this.diaBalance = 0;
        }else{
            this.diaBalance = parseInt(this.tipoFondo.tipofondos.diabalancexmail);
        }
		
    }
}
